import { TeambookReactSelect } from "../../../../default_components/TeambookReactSelect";
import { useTranslation } from "react-i18next";
import { useBookingModalStore, useBookingsCreatingStore, useBookingsEditingStore } from "../../../../../stores/planner";
import { shallow } from "zustand/shallow";
import PropTypes from "prop-types";

const UsersSelect = ({
  createActions,
  collapsedUsers,
  orderedPlannerUsers,
  createWindowOpened,
  createBookingsRef,
  usersToCreateBookings,
  setUsersToCreateBookings,
}) => {
  const { t } = useTranslation();

  const [bookingsCreating, setBookingsCreating] = useBookingsCreatingStore(
    (state) => [state.bookingsCreating, state.setBookings],
    shallow
  );
  const [editingBookings] = useBookingsEditingStore((state) => [state.bookingsEditing], shallow);
  const [deleteSelectedBookingsAfterSave, setDeleteSelectedBookingsAfterSave] = useBookingModalStore(
    (state) => [state.deleteSelectedBookingsAfterSave, state.setDeleteSelectedBookingsAfterSave],
    shallow
  );

  const modalType = createWindowOpened ? "creating" : "editing";

  const usersCanBeChanged = () => {
    return createActions.usersCanBeChanged(bookingsCreating, orderedPlannerUsers);
  };

  const userOptions = () => {
    if (modalType === "editing") {
      return orderedPlannerUsers
        .filter((u) => !collapsedUsers.includes(u.id))
        .map((u) => ({ value: u.id, name: u.name }));
    } else {
      const userIds = [...new Set(orderedPlannerUsers.filter((u) => !collapsedUsers.includes(u.id)).map((u) => u.id))];

      return userIds.map((id) => ({ value: id, name: orderedPlannerUsers.find((u) => u.id === id).name }));
    }
  };

  const usersWithCreationBookings = () => {
    if (modalType === "editing") {
      const userIds = [
        ...new Set(
          editingBookings.map((booking) => {
            return deleteSelectedBookingsAfterSave ? null : booking.user_id;
          })
        ),
      ].filter((u) => u);

      return [...userIds, ...usersToCreateBookings.map((u) => u.value)]
        .map((userId) => {
          const user = orderedPlannerUsers.find((u) => u.id === userId);

          if (!user) {
            return null;
          }

          return { value: user.id, label: user.name };
        })
        .filter((u) => u);
    } else {
      return createActions.usersWithCreationBookings(bookingsCreating, orderedPlannerUsers);
    }
  };

  const changeCreationUsers = (users) => {
    if (modalType === "editing") {
      if (!users.filter((u) => u.value === editingBookings[0].user_id).length > 0) {
        setDeleteSelectedBookingsAfterSave(true);
      }

      setUsersToCreateBookings(users.filter((u) => u.value !== editingBookings[0].user_id));
    } else {
      createActions.changeCreationUsers(
        bookingsCreating,
        users,
        createBookingsRef,
        orderedPlannerUsers,
        setBookingsCreating
      );
    }
  };

  if (!usersCanBeChanged()) {
    return null;
  }

  return (
    <div style={{ marginTop: 16 }} className="row booking-window__grouped-data-element">
      <TeambookReactSelect
        fieldName={t("header.users")}
        value={usersWithCreationBookings()}
        onChange={(users) => changeCreationUsers(users)}
        options={userOptions()}
        isSearchable
        nameStyles={{ fontSize: 14, textAlign: "left" }}
        grayPlaceholder
        type="multiple"
        styles={{ width: "100%" }}
      />
    </div>
  );
};

UsersSelect.propTypes = {
  createActions: PropTypes.object.isRequired,
  collapsedUsers: PropTypes.array.isRequired,
  orderedPlannerUsers: PropTypes.array.isRequired,
  createWindowOpened: PropTypes.bool.isRequired,
  createBookingsRef: PropTypes.object.isRequired,
  usersToCreateBookings: PropTypes.array.isRequired,
  setUsersToCreateBookings: PropTypes.func.isRequired,
};

export default UsersSelect;
